module.exports = __webpack_public_path__ + "static/media/abubakar.16d35bdd.jpeg";